import { create } from 'zustand';

interface ProfileStore {
  version: number;
  invalidate: () => void;
}

export const useProfileStore = create<ProfileStore>((set) => ({
  version: 0,
  invalidate: () => set((s) => ({ version: s.version + 1 })),
}));
